import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportshirdicabservice() {



  const cardData =
  {
    keyword: ' Pune Airport to Shirdi Cab Service',
    heading: 'Sai Trupti Cabs: Pune Airport to Shirdi Cab Service',
    headingDescription: 'Sai Trupti Cabs offers convenient and reliable Pune Airport to Shirdi cab service, ensuring a seamless and comfortable start to your pilgrimage or visit. Our fleet of well‐maintained, air‐conditioned vehicles—ranging from sedans to SUVs—is available for pick‐up right from the arrival area at Pune Airport. Each ride features a background‐verified driver who ensures punctual arrival and safe, courteous service through the approximately 4–5-hour journey. With transparent pricing, door-to-door convenience, and 24×7 support, Sai Trupti Cabs makes your transfer from Pune Airport to Shirdi stress-free and comfortable — your trusted partner before your journey begins.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the sacred heart of Shirdi and the most revered pilgrimage site in Maharashtra. Built in marble, it houses the resting place of Shri Sai Baba, radiating peace and divine energy. Devotees from across the world visit daily to offer prayers and witness the mesmerizing aarti ceremonies. The temple’s white marble statue of Sai Baba exudes serenity and compassion, reminding visitors of his eternal teachings of love, unity, and selfless service."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai Mosque holds immense spiritual importance as Sai Baba lived here for over 60 years. This humble structure symbolizes faith, patience, and divine grace, where Baba healed the sick and helped the needy. The sacred dhuni (eternal flame) still burns here, representing purity and spiritual continuity. Devotees visit Dwarkamai to experience Baba’s living presence and witness the divine simplicity that continues to guide millions of hearts toward goodness and truth."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is another significant shrine in Shirdi, where Sai Baba spent every alternate night during the last years of his life. The place still preserves his wooden bed, palkhi, and photographs that recreate the divine aura of his presence. The traditional palkhi procession from Dwarkamai to Chavadi is a highlight for devotees, reflecting the deep bond between the saint and his followers. It stands as a timeless reminder of discipline, devotion, and divine grace."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the exact spot where Sai Baba was first seen as a young boy meditating under a neem tree. Today, a small shrine with a marble statue of Baba and a sacred Shivling draws thousands of visitors seeking spiritual awakening. The neem tree’s roots are believed to have miraculous healing powers. Gurusthan beautifully connects Shirdi’s divine past with the living devotion of its present, inspiring faith and humility among pilgrims."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time daily, watering plants and meditating under trees. The garden still houses the lamp lit by Baba, which continues to burn eternally in his memory. Shaded paths, tranquil surroundings, and the fragrance of flowers make it a peaceful retreat for devotees. Lendi Baug reflects Baba’s deep love for nature and simplicity, reminding visitors that spirituality thrives in acts of care and compassion."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba first arrived in Shirdi and was affectionately addressed as 'Ya Sai' by the temple priest. Dedicated to Lord Khandoba, the temple signifies the moment when Baba’s divine journey in Shirdi began. Pilgrims visit this modest shrine to pay homage to both Lord Khandoba and Sai Baba’s first blessing in the town. It’s a sacred site connecting faith, history, and divine destiny."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is an open-air museum that artistically depicts the life and miracles of Sai Baba through realistic sculptures and dioramas. The peaceful environment, traditional architecture, and storytelling displays offer a beautiful blend of devotion and learning. Visitors, especially families, find it a perfect place to understand Baba’s message in a visual and interactive way. The village also features play areas and food stalls, making it a wholesome spiritual retreat."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a refreshing contrast to Shirdi’s spiritual ambiance, providing family-friendly entertainment and relaxation. Spread across 10 acres, it features thrilling slides, a wave pool, and dedicated zones for kids. After a divine darshan, visitors often unwind here to enjoy fun-filled moments with family. Its cleanliness, safety measures, and proximity to the temple make it one of Shirdi’s most popular leisure destinations."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Located within the Sai Baba Temple complex, Dixit Wada Museum showcases a collection of Sai Baba’s personal belongings — robes, utensils, footwear, and rare photographs. The museum preserves Baba’s legacy and offers a glimpse into his simple, ascetic lifestyle. Visitors feel a deep connection as they view artifacts that once touched the saint’s life. It’s a must-visit for devotees seeking to understand Sai Baba’s humility and timeless wisdom."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani and is famous for its unique open-air shrine where no door or lock exists in the entire village. The belief that Lord Shani protects every devotee instills immense faith among visitors. Pilgrims often combine their Shirdi darshan with a visit here, completing a spiritually enriching journey. The temple’s aura of trust and divine justice continues to attract devotees from all over India."
  }
],



"services": [
  {
    "name": "Pune Airport to Shirdi Cab Service",
    "description": "Reliable cab service from Pune Airport to Shirdi offering comfortable rides with professional drivers. Perfect for hassle-free travel directly from the airport to Shirdi."
  },
  {
    "name": "Pune Airport to Shirdi Taxi",
    "description": "Convenient taxi service from Pune Airport to Shirdi with AC and non-AC options, one-way and round trips, ensuring safe and timely travel."
  },
  {
    "name": "Pune Airport to Shirdi Car Hire",
    "description": "Car hire service from Pune Airport to Shirdi with a range of vehicles including Sedans, SUVs, and luxury cars for personalized travel."
  },
  {
    "name": "Pune Airport to Shirdi Innova Cab",
    "description": "Travel from Pune Airport to Shirdi in a spacious and comfortable Innova, ideal for families or small groups, with AC and professional driver service."
  },
  {
    "name": "Pune Airport to Shirdi Ertiga Cab",
    "description": "Ertiga cab service from Pune Airport to Shirdi offering comfortable seating for groups, AC service, and reliable, safe travel for your journey."
  },
  {
    "name": "Pune Airport to Shirdi Sedan Cab",
    "description": "Sedan cab service from Pune Airport to Shirdi providing a smooth, comfortable ride with professional drivers and optional luxury amenities."
  },
  {
    "name": "Pune Airport to Shirdi One Way Taxi",
    "description": "One-way taxi service from Pune Airport to Shirdi at affordable rates, ideal for travelers seeking direct and efficient transport."
  },
  {
    "name": "Pune Airport to Shirdi Drop Cab",
    "description": "Drop cab service from Pune Airport to Shirdi, offering point-to-point travel with AC cars, professional drivers, and hassle-free service."
  },
  {
    "name": "Pune Airport to Shirdi Luxury Cab",
    "description": "Premium luxury cab service from Pune Airport to Shirdi with top-class vehicles, AC service, and professional chauffeur for a comfortable journey."
  },
  {
    "name": "Pune Airport to Shirdi Outstation Cab",
    "description": "Outstation cab service from Pune Airport to Shirdi for long-distance travel, including tolls, driver allowances, and comfortable vehicle options."
  },
  {
    "name": "Affordable Pune Airport to Shirdi Cab",
    "description": "Budget-friendly cab service from Pune Airport to Shirdi, offering comfortable AC vehicles, reliable drivers, and transparent fares."
  },
  {
    "name": "Pune Airport to Shirdi AC Cab",
    "description": "AC cab service from Pune Airport to Shirdi providing a comfortable and cool travel experience with professional drivers and safe rides."
  },
  {
    "name": "Pune Airport to Shirdi Online Booking",
    "description": "Book your Pune Airport to Shirdi cab online instantly with multiple vehicle options, secure payments, and transparent fares for a stress-free experience."
  },
  {
    "name": "Pune Airport to Shirdi Travel Service",
    "description": "Comprehensive travel service from Pune Airport to Shirdi including cabs, drop services, and luxury options ensuring a smooth and comfortable journey."
  },
  {
    "name": "Pune Airport to Shirdi Cab near Me",
    "description": "Find Pune Airport to Shirdi cabs near your location for quick and convenient booking, with professional drivers and reliable service."
  }
],
"tableData": [
  ["Pune Airport to Shirdi Cab Service", "Pune Airport to Shirdi Taxi"],
  ["Pune Airport to Shirdi Car Hire", "Pune Airport to Shirdi Innova Cab"],
  ["Pune Airport to Shirdi Ertiga Cab", "Pune Airport to Shirdi Sedan Cab"],
  ["Pune Airport to Shirdi One Way Taxi", "Pune Airport to Shirdi Drop Cab"],
  ["Pune Airport to Shirdi Luxury Cab", "Pune Airport to Shirdi Outstation Cab"],
  ["Affordable Pune Airport to Shirdi Cab", "Pune Airport to Shirdi AC Cab"],
  ["Pune Airport to Shirdi Online Booking", "Pune Airport to Shirdi Travel Service"],
  ["Pune Airport to Shirdi Cab near Me", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune Airport to Shirdi Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers dependable and comfortable cab services from Pune Airport to Shirdi — perfect for pilgrimage trips, family travel or a seamless one‑way journey."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our fare structure for Pune Airport to Shirdi starts at approximately ₹2,849 for hatchbacks, ₹2,999 for sedans and around ₹4,249 for SUVs (one‑way). :contentReference[oaicite:4]{index=3}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from economical hatchbacks, comfortable sedans, spacious SUVs or premium cars to suit your group size, luggage and comfort requirements for the route from Pune Airport to Shirdi."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our drivers are courteous, punctual and familiar with the Pune‑to‑Shirdi route—ensuring a safe, smooth and timely journey from the airport."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickup at Pune Airport (terminal or city driveway) and drop‑offs at your preferred location in Shirdi including temples, railway station or hotel."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and equipped for long‑distance travel so your Pune Airport to Shirdi ride is comfortable and hassle‑free."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with booking, flight schedule changes, route planning and any travel assistance."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune Airport to Shirdi cab easily via call, WhatsApp or our website — receive instant confirmation and rapid vehicle dispatch for your journey."
  }
]





































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune Airport to Shirdi cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Pune Airport to Shirdi for one way, round trip, and group travel.',
  },
  {
    question: 'How can I book a cab from Pune Airport to Shirdi with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune Airport to Shirdi cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune Airport to Shirdi?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune Airport to Shirdi trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune Airport to Shirdi for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and religious travel from Pune Airport to Shirdi.',
  },
  {
    question: 'Is the Pune Airport to Shirdi cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune Airport to Shirdi for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune Airport to Shirdi cab fares?',
    answer: 'Our cab fares start from ₹2,500 for sedans, ₹3,000–₹3,800 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune Airport to Shirdi cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune Airport to Shirdi cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune Airport to Shirdi cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune Airport to Shirdi cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Booking a cab from Pune Airport to Shirdi with Sai Trupti Cabs was hassle-free. The driver arrived on time and drove safely.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Kapoor',
    feedback: 'Sai Trupti Cabs provided excellent service from Pune Airport to Shirdi. The cab was comfortable, and the journey was smooth.',
    rating: 5,
  },
];
































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport to Shirdi Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune Airport to Shirdi Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-shirdi-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune Airport to Shirdi Cab Service | Safe & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Airport to Shirdi Cab Service with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport to Shirdi Cab Service, Pune Airport to Shirdi Taxi, Pune Airport to Shirdi Car Hire, Pune Airport to Shirdi Innova Cab, Pune Airport to Shirdi Ertiga Cab, Pune Airport to Shirdi Sedan Cab, Pune Airport to Shirdi One Way Taxi, Pune Airport to Shirdi Drop Cab, Pune Airport to Shirdi Luxury Cab, Pune Airport to Shirdi Outstation Cab, Affordable Pune Airport to Shirdi Cab, Pune Airport to Shirdi AC Cab, Pune Airport to Shirdi Online Booking, Pune Airport to Shirdi Travel Service, Pune Airport to Shirdi Cab near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportshirdicabservice;